import { useMutation } from "@tanstack/react-query";

import { markInboundDocumentJobUserMatch } from "#/api/inbound-document-jobs.api";
import { InboundDocumentJob } from "#/api/inbound-document-jobs.type";

type MatchPayload = {
  jobId: string;
  patientUserId: string;
  patientId?: string | null;
  subjectUserId?: string | null;
  statusDetail?: string | null;
  metadata?: Record<string, unknown>;
};

export function useMatchInboundDocumentJobUser() {
  return useMutation<InboundDocumentJob, Error, MatchPayload>({
    mutationKey: ["inbound-document-jobs", "match-user"],
    mutationFn: ({ jobId, ...rest }) =>
      markInboundDocumentJobUserMatch(jobId, rest),
  });
}

export default useMatchInboundDocumentJobUser;
